import { render, staticRenderFns } from "./TabPlanos.vue?vue&type=template&id=abf5f7e0"
import script from "./TabPlanos.vue?vue&type=script&lang=ts"
export * from "./TabPlanos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports